exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".FavoriteButton__favorite_button--2LM_X {\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  padding-left: 0;\n  padding-right: 0;\n  color: var(--gray-6); }\n  .FavoriteButton__favorite_button--2LM_X:hover > svg > path {\n    fill: var(--daybreak-5); }\n  .FavoriteButton__favorite_button--2LM_X .FavoriteButton__selected--3fH9w {\n    color: var(--yellow-6); }\n", ""]);

// exports
exports.locals = {
	"favorite_button": "FavoriteButton__favorite_button--2LM_X",
	"selected": "FavoriteButton__selected--3fH9w"
};